import React, {useEffect, useState} from 'react';
import {FormPageFieldComponentProps} from 'types/formPage';

import {withFormikFormControl} from '../FormikFormControl';
import {useFormikContext} from "formik";
import DisplayRendering from "../DisplayRendering";

export type LinkedFieldDisplayProps = FormPageFieldComponentProps;

const LinkedFieldDisplay = ({details, extraConfig = {} }: LinkedFieldDisplayProps) => {
  const {linked_field_id = ''} = extraConfig
  const {
    values
  } = useFormikContext();
  console.log('LinkedFieldDisplay', linked_field_id, values[linked_field_id], values)
  return <DisplayRendering value={values[linked_field_id]} name={linked_field_id} details={details} extraConfig={extraConfig} />
};

export default withFormikFormControl({  })(LinkedFieldDisplay);
